<template>
  <CFooter :fixed="false">
    <div>
      <a href="https://codelinesolutions.com/" target="_blank">CLS</a>
      <span class="ml-1">&copy;SECURE {{new Date().getFullYear()}}.</span>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
